
const selectors$4 = {
  customerLoginContainer: 'customer-login',
  recoverPasswordForm: '#RecoverPasswordForm',
  customerLoginForm: '#CustomerLoginForm',
  hideRecoverPasswordLink: '#HideRecoverPasswordLink',
  showRecoverPasswordLink: '#RecoverPassword'
};

class CustomerLogin extends HTMLElement {
  constructor() {
    super();
    this.container = document.querySelector(selectors$4.customerLoginContainer);
    this.$container = $(this.container);

    this.checkUrlHash();
    this.resetPasswordSuccess();

    $(selectors$4.showRecoverPasswordLink, this.$container).on(
        'click',
        this.onShowHidePasswordForm.bind(this)
    );
    $(selectors$4.hideRecoverPasswordLink, this.$container).on(
        'click',
        this.onShowHidePasswordForm.bind(this)
    );
  }

  onShowHidePasswordForm(evt) {
    evt.preventDefault();
    this.toggleRecoverPasswordForm();
  }

  checkUrlHash() {
    var hash = window.location.hash;

    if (hash === '#recover') {
      this.toggleRecoverPasswordForm();
    }
  }

  toggleRecoverPasswordForm() {
    $(selectors$4.recoverPasswordForm).toggleClass('hide');
    $(selectors$4.customerLoginForm).toggleClass('hide');
  }

  resetPasswordSuccess() {
    if (!$('.reset-password-success').length) {
      return;
    }

    $('#ResetSuccess').removeClass('hide');
  }

}

customElements.define('customer-login', CustomerLogin);
